var exports = {
  "az": "Box__ypoCmg",
  "wy": "Box_1__0lDLoX",
  "Hx": "Flash__o07cpa",
  "pv": "Box_2__HjmqUf",
  "w9": "Box_3__en_I5G",
  "EY": "Text__oU-l9Z",
};

module.exports = exports;
